/*
  An example of a typical utility library. Things to notice:
  - This library is exported as a Class.
  - External dependencies are embedded into the class 'this' object: this.bitbox
  - `_this` maintains top-level context for `this`.
*/
'use strict'; // npm libraries
// Global handle to the instance of this Class.

var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

var _this;

var GetPubKey = /*#__PURE__*/function () {
  function GetPubKey(config) {
    _classCallCheck(this, GetPubKey);

    if (!config) {
      throw new Error('A config object must be passed when instantiating the GetPubKey Class.');
    }

    if (!config.bchjs) {
      throw new Error('An instance of bch-js must be passed when instantiating GetPubKey.');
    }

    this.bchjs = config.bchjs;
    _this = this;
  } // Make an axios call to the FullStack.cash API to look for the public key.


  _createClass(GetPubKey, [{
    key: "queryBlockchain",
    value: function () {
      var _queryBlockchain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addr) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(typeof addr !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Address must be a string');

              case 3:
                _context.next = 5;
                return _this.bchjs.encryption.getPubKey(addr);

              case 5:
                result = _context.sent;

                if (result.success) {
                  _context.next = 9;
                  break;
                }

                console.log('Public key could not be found on the blockchain.');
                return _context.abrupt("return", false);

              case 9:
                return _context.abrupt("return", result.publicKey);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.error('Error in get-pubkey.js/queryBlockchain()');
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      function queryBlockchain(_x) {
        return _queryBlockchain.apply(this, arguments);
      }

      return queryBlockchain;
    }()
  }]);

  return GetPubKey;
}();

module.exports = GetPubKey;